import React from 'react';
import { HostSettingsLayout } from '../../components/HostSettingsLayout';
import { DeleteAccountSection } from '../../components/DeleteAccountSection';
import { DownloadMyDataSection } from '../../components/DownloadMyDataSection';
import CookiePreferencesCard from '../../components/CookiePreferencesCard';
import AllowPhoneCallsCard from '../../components/AllowPhoneCallsCard';
import AllowReadReceiptsCard from '../../components/AllowReadReceiptsCard';

// 2026-06: the guest "Auto-message hosts on accept" toggle was removed —
// guests now ALWAYS auto-send the "Just accepted ✨" note to their host. The
// Privacy page keeps account deletion only.
export default function GuestPrivacyPage() {
  return (
    <HostSettingsLayout title="Privacy" dataTestId="guest-privacy-page">
      <AllowPhoneCallsCard dataTestId="guest-privacy-allow-phone-calls" />
      <AllowReadReceiptsCard dataTestId="guest-privacy-allow-read-receipts" />
      <CookiePreferencesCard dataTestId="guest-privacy-cookie-card" />
      <DownloadMyDataSection dataTestIdPrefix="guest-privacy" />
      <DeleteAccountSection dataTestIdPrefix="guest-privacy" />
    </HostSettingsLayout>
  );
}
